import Tooltip from './Tooltip';

export default function CustomButton( { text, color, onClick } ){
  return (
    <button className = "customButton" onClick = { onClick }>
      <div className ="innerBox">
          <svg
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 131 51" 
            style = { { width : "100%", height : "100%"} }
            preserveAspectRatio="none"
          >

          <path
            className="button-fill"
            d = "M 0 4 Q 0 0, 5 0L 127 0 Q 131 0, 131 4L 131 37 Q 131 38, 129 41L 123 47 Q 120 50, 117 51L 4 51 Q 0 51, 0 47L 0 4"
            fill = { `rgba(${color}, 0.08` }
          />

          <path
            className = "button-stroke"
            d="M5 0.5h122a3.5 3.5 0 0 1 3.5 3.5v33c0 1-0.5 2.5-2 4l-6 6c-2 2-4 3.5-6 3.5H5a4.5 4.5 0 0 1-4.5-4.5V4a3.5 3.5 0 0 1 3.5-3.5z"
            fill = "none"
            stroke = { `rgba(${color}, 0.88` }
            strokeWidth = "2"
            strokeLinecap = "round"
            strokeLinejoin = "round"
            vectorEffect="non-scaling-stroke"
          />
          </svg>
      </div>
      
      <div className = "buttonContent">
        <div className = "iconWrapper">
            <span className = "material-symbols-outlined" style={{ color: `rgb(${color})` }}>favorite</span>
        </div>
        
        <div>{text}</div>
        </div>

        {/* <Tooltip text = "asd"/> */}
      
    </button>
  );
};